<template>

	<div :class="{ 'opportunity-filters': true, empty: ( filters.saved.length === 0 && filters.preset.length === 0 ), 'is-in-modal' :isInModal }" v-if="loaded">

		<span class="svg minimize" title="Minimize" @click="minimize"><font-awesome-icon icon="down-left-and-up-right-to-center" /></span>

		<div 
			v-for="(savedFilter, savedFilterIndex) in filterTypes" 
        	:key="savedFilterIndex" 
			:class="{ 'current-filters': true, empty: filtersProcessed[savedFilter.type].length === 0, 'no-padding-top': savedFilter.type==='saved-hidden',  hide: ( filtersProcessed[savedFilter.type].length === 0 && savedFilterIndex > 0 ) }"
		>

			<span 
				:class="{'large-button':true, 'add-new': true, 'has-brand-ignores': hasBrandIgnores}" 
				@click="addNew" 
				v-if="savedFilterIndex===0"
			><font-awesome-icon icon="magnifying-glass" /> New Search/Filter</span>

			<div :class="{'brand-filters': true, 'has-brand-ignores': hasBrandIgnores}" v-if="savedFilterIndex===0">

				<span 
					:class="{'large-button': true, 'add-new': true, 'brand-tags': true }" 
					@click="showTagger=true" 
					v-if="savedFilterIndex===0&&Object.keys(projectInfo).length>0" 
				>
					{{brandFiltersBtn}} 
					<Tip :styles="{ 'font-size': '12px' }" position="fromRight" class="filter-tip"><span>When enabled, any keywords matching these filters will be ignored. When you update your brand filters the keyword counts may be out of sync for a few minutes whilst we recount things.</span></Tip>	
				</span>

				<Switcher 
					:sameColour="true" 
					v-model="useBrandFilters" 
					v-if="hasBrandIgnores"
					:title="useBrandFilters?'Turn off brand filters':'Turn on brand filters'"
					:styles="'margin: 0;'"
		        />

			</div>

			<h2 
				:class="{'saved-filters-title':true,small:savedFilter.type==='saved-hidden',first:savedFilterIndex===0,'no-margin-bottom':savedFilter.type==='saved-hidden'&&!showHidden}" 
				v-if="filtersProcessed[savedFilter.type].length>0"
			><span>{{savedFilter.type==='saved-hidden'?savedHiddenFiltersTitle:savedFilter.name}}</span> <Switcher 
				:sameColour="true" 
				v-model="showHidden" 
				v-if="savedFilter.type==='saved-hidden'"
				:switcherLabel2="showHidden?'Hide':'Show'"
				:styles="'margin: 0;'"
			/></h2>

			<div v-if="filtersProcessed[savedFilter.type].length>0&&(savedFilter.type!=='saved-hidden' || showHidden)">

				<span 
					 v-for="(savedFilter2, savedFilter2Index) in filtersProcessed[savedFilter.type]" 
        			:key="savedFilterIndex+'-'+savedFilter2Index" 
					:class="{filter: true }"
				>
					<span :class="{label:true,hasTip:!!savedFilter2.filtersFriendly}">{{savedFilter2.name}}<Tip v-if="savedFilter2.filtersFriendly" :styles="{ 'font-size': '12px' }" position="fromCentre" class="filter-tip hideQ"><span v-html="savedFilter2.filtersFriendly" /></Tip></span>

					<span class="svg run" title="Run" @click="searchFilters( savedFilter2, 'run' )"><font-awesome-icon icon="play" /></span>

					<span class="svg edit" title="Edit" @click="searchFilters( savedFilter2, 'edit' )"><font-awesome-icon icon="pencil-alt" /></span>

					<span class="svg delete" title="Delete" @click="searchFilters( savedFilter2, 'delete' )" v-if="savedFilter.type==='saved'"><font-awesome-icon icon="trash-alt" /></span>

				</span>

				<hr v-if="savedFilterIndex===0 && ( filtersProcessed.saved.length > 0 || filtersProcessed['saved-hidden'].length > 0 )" />

			</div>

		</div>

		<Tagger 
			v-if="showTagger" 
			:settings="taggerSettings"
			@close-tagger="closeTagger"
			:lowerCaseTags="false"
		/>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import Tip from './Tip.vue'
import Tagger from './Tagger.vue'
import FormInput from './Form/Input.vue'
import Switcher from './Switcher.vue'
export default {
	name: 'OpportunityFilters',
	props: {
		type: {
			type: String
		},
		projectInfo: {
			type: Object
		},
		url: {
			type: String
		},
		hasPageReports: {
			type: Boolean,
			default: false
		},
		isInModal: {
			type: Boolean,
			default: false
		},
		filters: {
			type: Object,
			default: function () {

				return { saved: [], preset: [] };

			}
		
		}
	},
	components: { Tip, Tagger, FormInput, Switcher },
	data() {

		return {
			current: null,
			loaded: true,
			showTagger: false,
			useBrandFilters: false,
			showHidden: false,
			taggerType: null,
			popular: [],
			lastFilter: null
		}

	},
	watch: {
		useBrandFilters: function (new1, old1) {

			if ( new1 !== old1 ) this.updateProjectBrandIgnoreSetting ();

		},
		useBrandFiltersProject: function (new1, old1) {

			this.useBrandFilters = this.useBrandFiltersProject;

		}
	},
	computed: { 

		useBrandFiltersProject () {

			return !!this.projectInfo.brandIgnoreSetting;

		},

		filterTypes () {

			return [
				{ type: 'preset',name: 'Opportunity Filters' },
				{ type: 'saved',name: 'Your Saved Filters' },
				{ type: 'saved-hidden', name: 'Saved Filters Not Associated With This Project' }
			];

		},

		filtersProcessed () {

			let filters = {};

			this.filterTypes.forEach ( function ( filterType ) {

				filters[filterType.type] = [];

			}.bind(this));

			['preset','saved'].forEach ( function ( filterType ) {
			
				this.filters[filterType].forEach ( function ( filter ) {

					let h = '';

					if ( !filter.pageReportsOnly || this.hasPageReports ) {

						if ( filterType === 'saved' && !filter.allProjects && filter.projects.indexOf( this.projectInfo._id ) === -1 ) h = '-hidden';

						filters[filterType+h].push( filter );

					}

				}.bind(this));

			}.bind(this));

			return filters;

		},

		savedHiddenFiltersTitle () {

			let n = this.filtersProcessed['saved-hidden'].length;

			return n + ' Hidden Filter'+( n > 1 ? 's' : '' )+' Not Associated With This Project';

		},
		
		taggerSettings () {

			if ( this.taggerType === 'popular' ) {

				return { 
					tags: this.popular, 
					returnOnly: true, 
					tagName: 'Popular keyword', 
					buttonText: 'Run Filter',
					needsUpdateAlways: true,
					flipButton: true,
					title: 'Add/Remove Popular Keywords', 
					availableTags: this.popular
				};

			}

			return { 
				tags: this.projectInfo.brandIgnores, 
				returnOnly: true, 
				tagName: 'Filter', 
				title: 'Add Branding Filters', 
				availableTags: []
			};

		},
		brandFiltersBtn () {

			let label = 'Add Brand Filters';

			if ( this.hasBrandIgnores ) {

				label += ' ('+this.projectInfo.brandIgnores.length+')';

			}

			return label;

		},
		hasBrandIgnores () {
			
			return ( typeof this.projectInfo.brandIgnores !== 'undefined' && this.projectInfo.brandIgnores.length > 0 );

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		minimize () {

			this.$emit( 'minimize' ); 

		},

		closeTagger (info) {

			this.showTagger = false;
			
			general.modalClose();
			
			if ( typeof info !== 'object' || Object.keys( info ).length === 0 ) return;

			if ( this.taggerType === 'popular' ) {

				this.lastFilter.filters[0].keyword.value = [];
				this.lastFilter.filters[0].keyword.comparison = 'like';
				this.lastFilter.filters[1] = general.stripObject( this.lastFilter.filters[0] );
				this.lastFilter.filters[1].keyword.comparison = 'starts_with';
				this.lastFilter.filters[2] = general.stripObject( this.lastFilter.filters[0] );
				this.lastFilter.filters[2].keyword.comparison = 'ends_with';

				info.tags.forEach( function (tag) {

					this.lastFilter.filters[0].keyword.value.push( ' ' + tag + ' ' );
					this.lastFilter.filters[1].keyword.value.push( tag + ' ' );
					this.lastFilter.filters[2].keyword.value.push( ' ' + tag );

				}.bind(this));

				this.lastFilter.filters[0].keyword.value = this.lastFilter.filters[0].keyword.value.join('||');
				this.lastFilter.filters[1].keyword.value = this.lastFilter.filters[1].keyword.value.join('||');
				this.lastFilter.filters[2].keyword.value = this.lastFilter.filters[2].keyword.value.join('||');

				this.$emit( 'searchFilters', { info: general.stripObject( this.lastFilter ), action: 'run' } );

			}
			else {

				ApiService.put( 'projects/update-brand-ignores/' + this.projectInfo._id, info.tags )
				.then( function( info ) {

					this.projectInfo.brandIgnores = info.data;
					this.$emit( 'brandIgnoreSettingChange', { type: this.type, brandIgnoreSetting: this.useBrandFilters, forceLoad: true } );

				}.bind(this))
				.catch( function(err) {

				}.bind(this));

			}

			this.taggerType = null;

		},

		updateProjectBrandIgnoreSetting () {
			
			if ( Object.keys( this.projectInfo ).length === 0 || this.projectInfo.brandIgnoreSetting === this.useBrandFilters ) return;

			ApiService.put( 'projects/update-brand-ignore-setting/' + this.projectInfo._id, { brandIgnoreSetting: this.useBrandFilters } )
			.then( function( info ) {

				this.$emit( 'brandIgnoreSettingChange', { type: this.type, brandIgnoreSetting: this.useBrandFilters } );

			}.bind(this))
			.catch( function(err) {

			}.bind(this));

		},

		addNew () {

			this.searchFilters ( null, 'edit' );

		},

		searchFilters ( info, action ) {

			if ( action === 'delete' ) {

				this.$dialog
				.confirm( "Are you sure?", { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText(true);

					ApiService.delete( 'google/opportunities/filters/' + info._id )
					.then( function( info ) {

						this.updateLoadingText();
						this.getFilters ();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

						general.$snotify (this,'error','Delete Filter',err);

					}.bind(this));

				}.bind(this))
				.catch(function() {});

			}
			else {

				if ( !!info && info.runCallback ) {
					
					switch ( info.runCallback ) {

						case 'selectPopular':

							this.popular = info.filters[0].keyword.value.split('||');
							this.lastFilter = general.stripObject( info );
							this.taggerType = 'popular';
							this.showTagger = true;

						break;

					}

				}
				else {
				
					this.$emit( 'searchFilters', { info: general.stripObject( info ) || { filters: [] }, action: action === 'clear' ? 'run' : action, clear: action === 'clear' } );

				}

			}

		},

		getFilters () {

			this.updateLoadingText('Loading filters...');
			
			this.$emit('loadFilters');

		}
		
	},
	created () {

		this.useBrandFilters = !!this.projectInfo.brandIgnoreSetting;

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.opportunity-filters {

	.rounded(5px);
	padding: 0 0 10px;
	margin-bottom: 15px;
	text-align: center;
	background-color: #fff;
	position: relative;

	.search-info {

		padding: 0 10px;

		.search-description {
			background-color: @formDefaultColour;
			.rounded(5px);
			padding: 10px 60px 10px 10px;
			margin-bottom: 15px;
			position: relative;
			.description {
				font-weight: 500;
				color: #fff;
			}
			.reset {
				color: @formDefaultColour;
				font-size: 0.8em;
				position: absolute;
				right: 10px;
				top: 11px;
				cursor: pointer;
				background-color:#fff;
				padding: 2px 4px;
		    	border-radius: 4px;
		    	.trans;
		    	&:hover {
		    		color:#fff;
		    		background-color:#000;
		    	}
			}
		}

		.search-tips {

			border: 3px solid @formDefaultColour;
			padding: 10px;
			font-weight: 500;
			.rounded(5px);

		}

	}

	&.empty {

		padding-bottom: 0;

	}

	.svg {

		background-color: @darkContrast;
		vertical-align: top;
		width: 20px;
		height: 20px;
		display: inline-block;
		padding: 4px;
		position: relative;
		.rounded(50%);
		.trans;
		cursor: pointer;
		
		svg {

			fill:#fff;
			color: #fff;
			width:50%;
			display: block;
			position: absolute;
			left: 25%;
			top: 10%;
			.trans;

		}

		&.run {

			svg {

				width: 40%;
				left: 35%;

			}

		}

		&.minimize {

			position: absolute;
			top: 11px;
			right: 11px;
			z-index: 2;

		}

		&:hover {

			background-color: #fff;

			svg {

				fill: @darkContrast;
				color: @darkContrast;

			}

		}

	}

	.current-filters {

		padding: 0;
		margin: 0;
		list-style: none;
		padding: 10px 10px 0;
		position: relative;

		&.hide {

			display: none;

		}

		.saved-filters-title {

			font-size: 16px;
			margin-bottom: 5px;

			span {

				display: inline-block;
				padding: 6px 5px 0 0;

			}

			&.small {

				font-size: 14px;

			}

			&.first {

				span {

					padding-top: 0;

				}

			}

		}

		hr {

			margin-bottom: 0;
			margin-top: 5px;
			border-color: @borderColor;

		}

		.large-button {

			background-color: @darkContrast;

			&.add-new {

				display: block;
				margin: 0 auto 10px;
				width: 250px;
				color: #fff;
				position: relative;

				&:hover {

					background-color: #F8FAFB;
					color: rgba(0, 0, 0, 0.8);

				}

				.tip {

					position: absolute;
				    display: inline-block;
				    top: 12px;
    				right: 10px;

				}

			}

		}

		.filter {

			position: relative;
			padding: 8px 10px 8px 7px;
			background-color: @highlightGrey;
			margin: 0 10px 10px 0;
			text-transform: none;
			border: 2px solid @highlightGrey;
			display: inline-block;
			.rounded(5px);
			vertical-align: top;

			> span {

				margin-left: 5px;
				&:first-child {
					margin-left: 0;
				}

			}

			.label {

				color: rgba(0,0,0,0.8);
				vertical-align: top;
				margin-right: 5px;
				display: inline-block;
				position: relative;

				&.hasTip {

					text-decoration: underline;
					text-decoration-style: dashed;
					cursor: help;

				}

			}

			&.selected {

				background-color: rgba(0,0,0,0.8);
				border-color: rgba(0,0,0,0.8);

				.label {

					color: @highlightGrey;

				}

			}

			&.selected {

				border-color: @highlightGrey;

			}

			.filter-tip {

				position: absolute;
				top: 2px;
				right: 2px;

				.tip-label {

					background-color: #fff;

				}

			}

		}

		&.empty {

			padding-bottom: 0;

			.large-button {

				&.add-new {


				}

			}
		}

	}

	.brand-filters {

		text-align: center;
		margin-bottom: 20px;

	    .brand-filter-tick {

	    	display: inline-block;

	    }

	    .large-button {

	    	&.add-new {

	    		padding: 10px 40px 10px 20px;

	    	}

	    }

	}

}
@media screen and (min-width: 768px) {
	.opportunity-filters {

		.current-filters {

			text-align: left;
			min-height: 25px;
			padding: 20px 20px 0;

			&.no-padding-top {

				padding-top: 0;

			}

			.saved-filters-title {

				margin: 0 0 8px 7px;
				font-size: 22px;

				&.small {

					margin-top: 12px;

				}

				&.no-margin-bottom {

					margin-bottom: 0;

				}

			}

			hr {

				margin-top: 10px;

			}

			.large-button {

				&.add-new {

					position: absolute;
				    padding: 4px 8px 3px;
				    width: 200px;
				    right: 270px;
				    z-index: 2;

					&.has-brand-ignores {

						right: 332px;

					}

				}

			}

			&.empty {

				min-height: 72px;

			}

		}

		.brand-filters {

			position: absolute;
		    right: 20px;
		    margin-bottom: 0;
		    padding-right: 25px;

		    .large-button {

		    	&.add-new {

		    		padding: 4px 46px 3px 18px;
				    width: auto;
				    right: auto;
				    margin-bottom: 4px;
				    position: relative;

				    .tip {

				    	top: 5px;
				    	right: 16px;

				    }

		    	}

		    }

			&.has-brand-ignores {

				 padding-right: 50px;
				right: 36px;

				.large-button {

					&.add-new {



					}

				}

			}

		    .switcher {

		    	position: absolute;
			    right: 0;
			    display: block;
			    left: auto;
			    margin: 0;
			    top: 3px;

		    }

		}

	}
}
@media screen and (min-width: 1024px) {
	.opportunity-filters {

		&.is-in-modal {

			margin-top: 0;

		}

	}
}
</style>